
import { post, } from 'utils/request';
import $api from "src/config/api.config" 
//获取class payinfo模块的链接数据
export const getClassPayInfo= async(patams = null) => {
  try {
    const res = await post($api.GET_CLASS_PAY_TYPE, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};

//获取支付的接口
export const getPayOrderByAirwallex4Sdk = async (params = null) => {
  try {
    const res = await post($api.GET_EMBED_PAY_ORDER_BY_AIRWALLEX, params);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
}
